import React, { useEffect, useContext } from "react";
import "./LoadingProgress.scss";
import { ProgressBar } from "react-bootstrap";
import { withRouter } from "react-router-dom";

import { LoadingContext } from "../../api/loading/LoadingContext";

function LoadingProgress({ location }) {
  const { loading, dispatchLoading } = useContext(LoadingContext);

  useEffect(() => {
    //console.log("loading progress effect");
    return () => {
      //console.log("loading progress done");
    };
  }, [loading, dispatchLoading, location]);

  return (
    <ProgressBar
      className="loading-progress"
      now={loading.progress}
    ></ProgressBar>
  );
}
export default withRouter(LoadingProgress);
